import React from "react";
import { Switch, Route, Redirect } from "react-router";

import Landing from "./../pages/Landing";
import QRCodeCards from "../pages/QRCodeCards";
import BoletinPJBC from "../pages/boletin/BoletinPJBC";

const USE_BOLETIN_PAGE = false;

const Pages = () => {
	return (
		<Switch>
			<Route path="/plg/:profile_code" exact component={QRCodeCards} />
			{USE_BOLETIN_PAGE ? <Route path="/boletin-pjbc" component={BoletinPJBC} /> : null}
			<Route path={["/", "/nosotros", "/servicios", "/talleres", "/contacto"]} exact component={Landing} />
			<Route path="*" component={() => <Redirect to="/" />} />
		</Switch>
	);
};

export default Pages;
